module.exports = __webpack_public_path__ + "static/media/bicoBronze.5a533525.png";